import defaultValues from '../lib/defaultValues.js'

const state = {
  // Priority Plan
  product: defaultValues.product,
  zipCodes: JSON.parse(JSON.stringify(defaultValues.zipCodes)),
  planBillingPeriodEndDate: defaultValues.planBillingPeriodEndDate,
  planBillingPeriodStartDate: defaultValues.planBillingPeriodStartDate,
  planNextBillingDate: defaultValues.planNextBillingDate,
  priorityPlanStatus: defaultValues.priorityPlanStatus,
  currentPlanName: defaultValues.currentPlanName,
  currentPlanPrice: defaultValues.currentPlanPrice,
  currentPlanZipCodes: JSON.parse(JSON.stringify(defaultValues.currentPlanZipCodes)),
  // Coupons
  couponBudget: defaultValues.couponBudget,
  couponBudgetedClicks: defaultValues.couponBudgetedClicks,
  couponCategory: defaultValues.couponCategory,
  couponCombosAllowed: defaultValues.couponCombosAllowed,
  couponCustomerReuses: defaultValues.couponCustomerReuses,
  couponDefaultResponse: defaultValues.couponDefaultResponse,
  couponDetails: defaultValues.couponDetails,
  couponDiscountedPrice: defaultValues.couponDiscountedPrice,
  couponExpiration: defaultValues.couponExpiration,
  couponFreeClicks: defaultValues.couponFreeClicks,
  couponId: defaultValues.couponId,
  couponListPrice: defaultValues.couponListPrice,
  couponName: defaultValues.couponName,
  couponPromotionalCode: defaultValues.couponPromotionalCode,
  couponStatus: defaultValues.couponStatus
}

const getters = {
  // Priority Plan
  getCurrentPlanName: (state, getters) => {
    return state.currentPlanName
  },
  getCurrentPlanPrice: (state, getters) => {
    return state.currentPlanPrice
  },
  getCurrentPlanZipCodes: (state, getters) => {
    return state.currentPlanZipCodes
  },
  getPlanBillingPeriodEndDate: (state, getters) => {
    return state.planBillingPeriodEndDate
  },
  getPlanBillingPeriodStartDate: (state, getters) => {
    return state.planBillingPeriodStartDate
  },
  getPlanNextBillingDate: (state, getters) => {
    return state.planNextBillingDate
  },
  getPriorityPlanStatus: (state, getters) => {
    return state.priorityPlanStatus
  },
  getProduct: (state, getters) => {
    return state.product
  },
  getZips: (state, getters) => {
    return state.zipCodes
  },
  // Coupons
  getCouponBudget: (state, getters) => {
    return state.couponBudget
  },
  getCouponBudgetedClicks: (state, getters) => {
    return state.couponBudgetedClicks
  },
  getCouponCategory: (state, getters) => {
    return state.couponCategory
  },
  getCouponCombosAllowed: (state, getters) => {
    return state.couponCombosAllowed
  },
  getCouponCustomerReuses: (state, getters) => {
    return state.couponCustomerReuses
  },
  getCouponDefaultResponse: (state, getters) => {
    return state.couponDefaultResponse
  },
  getCouponDetails: (state, getters) => {
    return state.couponDetails
  },
  getCouponDiscountedPrice: (state, getters) => {
    return state.couponDiscountedPrice
  },
  getCouponExpiration: (state, getters) => {
    return state.couponExpiration
  },
  getCouponFreeClicks: (state, getters) => {
    return state.couponFreeClicks
  },
  getCouponId: (state, getters) => {
    return state.couponId
  },
  getCouponListPrice: (state, getters) => {
    return state.couponListPrice
  },
  getCouponName: (state, getters) => {
    return state.couponName
  },
  getCouponPromotionalCode: (state, getters) => {
    return state.couponPromotionalCode
  },
  getCouponStatus: (state, getters) => {
    return state.couponStatus
  }
}

const mutations = {
  // Priority Plan
  addZip (state, zip) {
    state.zipCodes.push(zip)
  },
  clearZips (state) {
    state.zipCodes = []
  },
  removeZip (state, index) {
    state.zipCodes.splice(index, 1)
  },
  updateCurrentPlanName (state, name) {
    state.currentPlanName = name
  },
  updateCurrentPlanPrice (state, price) {
    state.currentPlanPrice = price
  },
  updateCurrentPlanZipCodes (state, zipCodes) {
    state.currentPlanZipCodes = zipCodes
  },
  updatePlanBillingPeriodEndDate (state, endDate) {
    state.planBillingPeriodEndDate = endDate
  },
  updatePlanBillingPeriodStartDate (state, startDate) {
    state.planBillingPeriodStartDate = startDate
  },
  updatePlanNextBillingDate (state, nextBillingDate) {
    state.planNextBillingDate = nextBillingDate
  },
  updatePriorityPlanStatus (state, planStatus) {
    state.priorityPlanStatus = planStatus
  },
  updateProduct (state, product) {
    state.product = product
  },
  updateZips (state, zips) {
    state.zipCodes = zips
  },
  // Coupons
  updateCouponBudget: (state, budget) => {
    state.couponBudget = budget
  },
  updateCouponBudgetedClicks: (state, budgetedClicks) => {
    state.couponBudgetedClicks = budgetedClicks
  },
  updateCouponCategory: (state, category) => {
    state.couponCategory = category
  },
  updateCouponCombosAllowed: (state, combosAllowed) => {
    state.couponCombosAllowed = combosAllowed
  },
  updateCouponCustomerReuses: (state, customerReuses) => {
    state.couponCustomerReuses = customerReuses
  },
  updateCouponDefaultResponse: (state, defaultResponse) => {
    state.couponDefaultResponse = defaultResponse
  },
  updateCouponDetails: (state, details) => {
    state.couponDetails = details
  },
  updateCouponDiscountedPrice: (state, discountedPrice) => {
    state.couponDiscountedPrice = discountedPrice
  },
  updateCouponExpiration: (state, couponExpiration) => {
    state.couponExpiration = couponExpiration
  },
  updateCouponFreeClicks: (state, freeClicks) => {
    state.couponFreeClicks = freeClicks
  },
  updateCouponId: (state, couponId) => {
    state.couponId = couponId
  },
  updateCouponListPrice: (state, listPrice) => {
    state.couponListPrice = listPrice
  },
  updateCouponName: (state, name) => {
    state.couponName = name
  },
  updateCouponPromotionalCode: (state, code) => {
    state.couponPromotionalCode = code
  },
  updateCouponStatus: (state, couponStatus) => {
    state.couponStatus = couponStatus
  }
}

const actions = {
  // Priority Plan
  async getPrice ({ state, rootGetters }) {
    var client = rootGetters.getPaymentApigClientFactory
    var params = {}
    var pathTemplate = '/advertising/price/'
    var method = 'GET'
    var additionalParams = {
      queryParams: {
        tier: state.product,
        nzips: state.zipCodes.length
      }
    }
    var body = {}
    try {
      var result = await client.invokeApi(params, pathTemplate, method, additionalParams, body)
      return result.data.cost
    } catch (error) {
      console.log(error)
    }
  },
  async getPriorityAdvertisingPlan ({ commit, rootGetters }) {
    var client = rootGetters.getBusinessApigClientFactory
    var params = {id: 'self'}
    var pathTemplate = '/businesses/{id}'
    var method = 'GET'
    var additionalParams = {}
    var body = {}
    var result = await client.invokeApi(params, pathTemplate, method, additionalParams, body)
    var advertisingPlan = result.data.advertising_plan
    if (advertisingPlan) {
      commit('updatePlanBillingPeriodEndDate', new Date(advertisingPlan.billing_period_end_date))
      commit('updatePlanBillingPeriodStartDate', advertisingPlan.billing_period_start_date)
      if (advertisingPlan.next_billing_date) {
        commit('updatePlanNextBillingDate', advertisingPlan.next_billing_date)
        commit('updatePriorityPlanStatus', true)
      } else {
        commit('updatePlanNextBillingDate', null)
        commit('updatePriorityPlanStatus', false)
      }
      commit('updateCurrentPlanName', advertisingPlan.current.name)
      commit('updateCurrentPlanPrice', advertisingPlan.current.price)
      commit('updateCurrentPlanZipCodes', advertisingPlan.current.zips)
      if (advertisingPlan.current.priority === 500) {
        commit('updateCouponFreeClicks', 5)
      } else {
        commit('updateCouponFreeClicks', 2)
      }
    }
  },
  // Coupons
  async checkPromotionalCode ({ commit, rootGetters }, promotionalCode) {
    var client = rootGetters.getCouponApigClientFactory
    var params = {}
    var pathTemplate = '/coupons/promotions'
    var method = 'POST'
    var additionalParams = {}
    var body = {
      'promotional_code': promotionalCode
    }

    var result = await client.invokeApi(params, pathTemplate, method, additionalParams, body)
    commit('updateCouponPromotionalCode', promotionalCode)
    return result.data.free_clicks
  },
  async createCoupon ({ state, rootGetters }, parameters) {
    var client = rootGetters.getCouponApigClientFactory
    var params = {
      business_id: parameters.businessId
    }
    var pathTemplate = '/businesses/{business_id}/coupons'
    var method = 'POST'
    var additionalParams = {}
    var body = {
      'payment_method_nonce': parameters.paymentMethodNonce,
      'category': state.couponCategory,
      'name': state.couponName,
      'list_price': state.couponListPrice,
      'discounted_price': state.couponDiscountedPrice,
      'details': state.couponDetails,
      'free_clicks': state.couponFreeClicks,
      'budgeted_clicks': state.couponBudgetedClicks,
      'budget': state.couponBudget,
      'default_response': state.couponDefaultResponse,
      'coupon_expiration': state.couponExpiration,
      'combos_allowed': state.couponCombosAllowed,
      'customer_reuses': state.couponCustomerReuses,
      'promotional_code': state.couponPromotionalCode
    }
    var result = await client.invokeApi(params, pathTemplate, method, additionalParams, body)
    return result
  },
  async getCoupons ({ commit, rootGetters }, parameters) {
    var client = rootGetters.getCouponApigClientFactory
    var params = {
      business_id: parameters.businessId
    }
    var pathTemplate = '/businesses/{business_id}/coupons'
    var method = 'GET'
    var additionalParams = {
      queryParams: {
        primary_coupon: true
      }
    }
    var body = {}
    try {
      var result = await client.invokeApi(params, pathTemplate, method, additionalParams, body)
      var coupon = result.data.data[0]
      if (coupon) {
        commit('updateCouponBudget', coupon.budget)
        commit('updateCouponBudgetedClicks', coupon.budgeted_clicks)
        commit('updateCouponCategory', coupon.category)
        commit('updateCouponCombosAllowed', coupon.combos_allowed)
        commit('updateCouponCustomerReuses', coupon.customer_reuses)
        commit('updateCouponDefaultResponse', coupon.default_response)
        commit('updateCouponDetails', coupon.details)
        commit('updateCouponDiscountedPrice', coupon.discounted_price)
        commit('updateCouponExpiration', coupon.coupon_expiration)
        commit('updateCouponFreeClicks', coupon.free_clicks)
        commit('updateCouponId', coupon.coupon_id)
        commit('updateCouponListPrice', coupon.list_price)
        commit('updateCouponName', coupon.name)
        if (coupon.primary_coupon) {
          commit('updateCouponStatus', true)
        } else {
          commit('updateCouponStatus', false)
        }
      }
    } catch (error) {
      console.log(error)
    }
  },
  async getCouponPrice ({ rootGetters }) {
    var client = rootGetters.getCouponApigClientFactory
    var params = {}
    var pathTemplate = '/coupons/price'
    var method = 'GET'
    var additionalParams = {}
    var body = {}
    try {
      var result = await client.invokeApi(params, pathTemplate, method, additionalParams, body)
      return result.data.coupon_price_per_click
    } catch (error) {
      console.log(error)
    }
  },
  async switchCouponStatus ({ dispatch, rootGetters, state }, parameters) {
    var client = rootGetters.getCouponApigClientFactory
    var params = {
      business_id: parameters.businessId,
      coupon_id: state.couponId
    }
    var pathTemplate = '/businesses/{business_id}/coupons/{coupon_id}'
    var method = 'PATCH'
    var additionalParams = {}
    var body = {}
    try {
      await client.invokeApi(params, pathTemplate, method, additionalParams, body)
      dispatch('getCoupons', { businessId: parameters.businessId })
    } catch (error) {
      console.log(error)
    }
  },
  async switchPriorityPlanExpiringStatus ({ dispatch, rootGetters }) {
    var client = rootGetters.getPaymentApigClientFactory
    var params = {}
    var pathTemplate = '/businesses/payments'
    var method = 'PATCH'
    var additionalParams = {}
    var body = {}
    try {
      await client.invokeApi(params, pathTemplate, method, additionalParams, body)
      dispatch('getPriorityAdvertisingPlan')
    } catch (error) {
      console.log(error)
      alert(error)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/products.js